import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { company } from '~/company/Company';
import { CompanyName } from '~/company/interface';
import { ROUTES } from '~/pages/Root/constants';

import { useGlobal } from './useGlobal';

/**
 * Body class that hides the floating JivoChat mobile button. The matching CSS
 * rule is injected next to the Jivo script in `server.js`, keep both in sync.
 */
export const JIVO_MOBILE_BUTTON_HIDDEN_CLASS = 'jivo-mobile-button-hidden';

/**
 * JS-14191: on DubaiExpress the floating JivoChat button is shown on mobile
 * only on the home page — elsewhere it overlaps the UI (with an active dialog
 * Jivo keeps a fixed max-z-index button/label above our sticky bars). The
 * widget itself stays loaded on every page, so the footer "Support" button can
 * still open the same conversation. Desktop is untouched. The rule is
 * route × breakpoint and is re-evaluated on SPA navigation, resize and
 * orientation change.
 */
export const useJivoMobileButtonVisibility = () => {
  const { isMobile } = useGlobal();
  const { pathname } = useLocation();

  const isHidden =
    company.is(CompanyName.DubaiExpress) &&
    isMobile &&
    pathname !== ROUTES.index;

  useEffect(() => {
    document.body.classList.toggle(JIVO_MOBILE_BUTTON_HIDDEN_CLASS, isHidden);

    return () => {
      document.body.classList.remove(JIVO_MOBILE_BUTTON_HIDDEN_CLASS);
    };
  }, [isHidden]);
};
